<template lang='pug'>
  #customer-account-receivable-list
    r-table(
      no-data-text='Sin datos.'
      no-remove
      ref='table'
      remind-key='customer-account-receivable-list'
      v-bind='tableProps' 
      @detail='submitDetail' 
      @remove='submitRemove' 
    )
    r-dialog( 
      content-class='grey lighten-3'
      no-confirm
      title='Nota de debito'
      v-model='dialogs.debit' 
    )
      r-form(
        class='white'
        no-submit
        reset-text='cerrar'
        v-bind='formDebitNoteProps'
        v-model='selected'
        @reset='toggleDialog("debit")'
      )

    r-dialog( 
      content-class='grey lighten-3'
      no-confirm
      title='Factura de venta'
      v-model='dialogs.invoice' 
    )
      r-form(
        class='white'
        no-submit
        reset-text='cerrar'
        v-bind='formInvoiceProps'
        v-model='selected'
        @reset='toggleDialog("invoice")'
      )
</template>

<script>
  // 
  import { mapActions, mapState } from 'vuex'
  import { RDialog, RForm, RTable } from '../../../components/reusable_components/next'
  // 
  import CustomerAccountReceivableModel from '../../../models/Sale/SlCustomerAccountReceivable'
  import CustomerAccountReceivableFilters from './SlCustomerAccountReceivableFilters'
  import CustomerAccountReceivableHeaders from './SlCustomerAccountReceivableHeaders'
  import SaleInvoiceFields from '../SlSaleInvoice/SlSaleInvoiceFields'
  import SaleDebitNoteFields from '../SlSaleDebitNote/SlSaleDebitNoteFields'
  // 
  export default {
    name: 'customer-account-receivable-list',
    components: {
      RDialog,
      RForm,
      RTable,
    },
    computed: {
      /**
       * 
       */
      formDebitNoteProps() {
        return {
          fields: SaleDebitNoteFields.variant('update').readonly(),
        }
      },
      /**
       * 
       */
      formInvoiceProps() {
        return {
          fields: SaleInvoiceFields.readonly(),
        }
      },
      /**
       * 
       */
      tableProps () {
        return {
          filters: CustomerAccountReceivableFilters,
          headers: CustomerAccountReceivableHeaders,
          service: CustomerAccountReceivableModel,
          mapperFilter: filter => ({
            ...filter,
            status: filter.status ? filter.status.join(',') : undefined,
          }),
          paramFilter: {
              //flag_pending_send_dte: true,
          },
        }
      },
    },
    data () {
        return {
          dialogs: {
            invoice: false,
            debit: false,
          },
          selected: {},
        }
    },
    methods: {

      //
      ...mapActions( 'MenuesModule', [
        'setTitleTopBar',
      ]),

      //
      ...mapActions('SnackbarModalModule', [
        'resetSnackbarState',
      ]),

      /**
       * Fetches the given item.
       * @param      {<type>}  item    The item
       * @return     {<type>}  { description_of_the_return_value }
       */
      fetch(item) {
        return item.is_invoice ? item.fetch('sl_sale_invoice') : item.fetch('sl_sale_debit_note')
      },

      /**
       * Sets the selected.
       * @param      {<type>}  item    The item
       */
      setSelected(item) {
        this.selected = item.reset()
      },

      /**
       * { function_description }
       * @param      {<type>}  event   The event
       */
      submitDetail(event) {
        this.toggleDialog(event.item.is_invoice ? 'invoice' : 'debit')
        this.fetch(event.item).then(this.setSelected)
      },

      /**
       * { function_description }
       * @param      {<type>}  dialogName  The dialog name
       */
      toggleDialog(dialogName) {
        this.dialogs[dialogName] ^= 1
      },
    },
    beforeMount () {
        this.setTitleTopBar('Documentos por cobrar')
    },
  }
</script>
